import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import StationMap from "../../components/StationMap";

export default function SafetyZones() {
  const [stations, setStations] = useState([]);
  const [emergency, setEmergency] = useState(null);
  const [overview, setOverview] = useState(null);

  useEffect(() => {
    const tick = async () => {
      const [{ data: s }, { data: e }, { data: o }] = await Promise.all([
        api.get("/stations"),
        api.get("/emergency"),
        api.get("/analytics/overview"),
      ]);
      setStations(s); setEmergency(e); setOverview(o);
    };
    tick();
    const t = setInterval(tick, 5000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="p-6 lg:p-8">
      <div className="mb-6">
        <div className="bin-label">JURISDICTION · NYC</div>
        <h1 className="text-3xl font-black tracking-tighter mt-1">Network Status Map</h1>
        <p className="text-sm text-zinc-500 mt-2">Live status of all energy nodes in your jurisdiction.</p>
      </div>

      {overview && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
          <KPI label="Stations Online" value={`${overview.stations_online}/${overview.stations_total}`} color="#4ADE80" />
          <KPI label="Capacity" value={`${overview.total_capacity_kw}kW`} color="#00E5FF" />
          <KPI label="Battery Network" value={`${overview.battery_state_pct}%`} color="#FFA800" />
          <KPI label="Emergency Mode" value={emergency?.active ? "ACTIVE" : "OFF"} color={emergency?.active ? "#FF3838" : "#71717A"} />
        </div>
      )}

      <StationMap stations={stations} emergency={emergency?.active} height={520} />

      {emergency?.active && (
        <div className="mt-4 bin-card p-4 border-red-500/40">
          <div className="bin-label text-red-400">EMERGENCY MODE ENGAGED</div>
          <div className="mt-1 text-sm">
            Zone: <span className="font-mono">{emergency.zone || "network-wide"}</span> ·
            By: <span className="font-mono">{emergency.activated_by}</span> ·
            Reason: <span className="font-mono">{emergency.reason || "—"}</span>
          </div>
        </div>
      )}
    </div>
  );
}

function KPI({ label, value, color }) {
  return (
    <div className="bin-card p-4">
      <div className="bin-label">{label}</div>
      <div className="text-2xl font-black font-mono mt-1" style={{ color }}>{value}</div>
    </div>
  );
}
